import axios from 'axios';
import store from '../store/index';
import { localStorageHelper } from '../utils/localStorageHelper';

// Axios interceptor to add x-client-language and x-client-country headers to all requests
axios.interceptors.request.use(
  (config) => {
    // Get language and country from Redux store
    const state = store.getState();
    const contentLocalization = state.localization?.contentLocalization;
    const productLocalization = state.product?.productLocalization;
    
    // Priority: Redux store > localStorage > default
    let language = 
      contentLocalization?.language || 
      productLocalization?.language ||
      localStorageHelper.getLanguage() ||
      'en-us'; // default fallback
    
    let country = 
      contentLocalization?.location || 
      productLocalization?.countryName ||
      productLocalization?.location ||
      localStorageHelper.getCountry() ||
      'USA'; // default to USA if no country
    
    // Normalize language to lowercase (e.g., "tr-TR" -> "tr-tr")
    if (language) {
      language = language.toLowerCase();
    }
    
    // Add headers to request
    if (language) {
      config.headers['x-client-language'] = language;
    }
    
    if (country) {
      config.headers['x-client-country'] = country;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;

